import { FC } from "react";
import { Box, Text, TextProps } from "@chakra-ui/react";

interface Props extends TextProps {
  beforeProps?: TextProps["_before"];
  fontSize?: string;
  fontWeight?: string;
  highlightColor: string;
}

export const Highlight: FC<Props> = ({
  fontSize,
  fontWeight = "black",
  highlightColor,
  ...props
}) => {
  return (
    <>
      <Text
        as="span"
        fontWeight={fontWeight}
        position="relative"
        px={2}
        py={1}
        zIndex={0}
        whiteSpace="nowrap"
        css={{
          "&::before": {
            background: highlightColor,
            clipPath: `url(#highlight)`,
            content: '""',
            height: "100%",
            left: 0,
            position: "absolute",
            top: 0,
            width: "100%",
            zIndex: -1,
          },
        }}
        {...props}
      />
      <Box position="absolute">
        <svg width="0" height="0">
          <clipPath id="highlight" clipPathUnits="objectBoundingBox">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0.748865 0.90654C0.7311 0.912831 0.70596 0.925529 0.640771 0.959471C0.549977 1.00674 0.461529 1.00346 0.390689 0.994819C0.360392 0.991124 0.334846 0.986926 0.311644 0.983113C0.272584 0.976694 0.240165 0.971366 0.202899 0.971366H0V0.0701496H0.202899C0.254448 0.0701496 0.313246 0.0795598 0.361115 0.087221C0.380613 0.0903416 0.398298 0.093172 0.412942 0.094958C0.473997 0.102405 0.515354 0.0991188 0.548145 0.0820454C0.550093 0.0810311 0.552023 0.0800257 0.553937 0.0790293C0.609374 0.0501576 0.650309 0.028839 0.684967 0.0165658C0.727665 0.00144569 0.760036 0 0.797101 0H1V0.901217H0.797101C0.766945 0.901217 0.759787 0.902672 0.748865 0.90654Z"
              fill="white"
            />
          </clipPath>
        </svg>
      </Box>
    </>
  );
};
